const steps = {
  INFORMATION: "YOUR_INFORMATION",
  ADDRESS: "YOUR_ADDRESS",
};

export default steps;
